// modules/init-ajax-load-more.js

/**
 * Modulo AJAX Load More per i Post
 * 
 * - Inizializza il bottone "Load More" per caricare più post senza ricaricare la pagina
 * - Usa Fetch API per la richiesta AJAX al server
 * - Gestisce lo stato di caricamento e disabilita il bottone durante il caricamento
 * - Aggiorna il bottone quando non ci sono più post da caricare
 * - Logga messaggi utili per debug
 * 
 * Requisiti:
 * - Un bottone con 👉 id "load-more-btn" e data attributes "data-total-pages" e "data-category"
 * - Un container con classi 👉 id "post-grid-container" per inserire i nuovi post
 * - La variabile globale coopsalute_ajax con ajax_url e nonce
 * 
 * Nota: questo modulo è specifico per la struttura del tema Coop Salute e potrebbe richiedere adattamenti per altri temi o strutture HTML.
 */

export function initLoadMorePosts() {

    const btn = document.getElementById('load-more-btn');
    if (!btn) {
        console.warn('Load More → Bottone con id "load-more-btn" non trovato.');
        return;
    }

    // Selettore specifico per la griglia dei post
    const postsContainer = document.getElementById('post-grid-container');

    if (!postsContainer) {
        console.warn('Load More → Container #post-grid-container non trovato.');
        return;
    }

    let page = 1;
    let loading = false;
    const maxPages = parseInt(btn.dataset.totalPages || 1);
    const category = btn.dataset.category || 0;

    console.log('Load More inizializzato → ', { maxPages, category, page });

    btn.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('Click su Load More. Pagina corrente → ', page);

        if (loading || page >= maxPages) return;

        loading = true;
        page++;
        btn.disabled = true;
        
        const originalText = btn.innerHTML;
        // Spinner Bootstrap 5
        btn.innerHTML = `
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Caricamento...
        `;

        const formData = new FormData();
        formData.append('action', 'coopsalute_load_more');
        formData.append('page', page);
        formData.append('category', category);
        formData.append('security', coopsalute_ajax.nonce);

        fetch(coopsalute_ajax.ajax_url, {
            method: 'POST',
            body: formData
        })
            .then(response => response.text())
            .then(data => {
                if (data.trim() !== '') {

                    // 👉 Nuovi post
                    postsContainer.insertAdjacentHTML('beforeend', data);

                    // Ripristino pulsante
                    btn.innerHTML = originalText;
                    btn.disabled = false;
                    loading = false;

                    // Se siamo all'ultima pagina
                    if (page === maxPages) {
                        btn.innerHTML = 'Non ci sono altri articoli';
                        btn.disabled = true;
                        btn.classList.add('disabled');
                        // Opzionale → sfumare il bottone o nasconderlo
                        // btn.style.display = 'none';
                    }
                } else {
                    // Nessun altro post disponibile 
                    // anche se maxPages non è stato raggiunto, per sicurezza
                    btn.innerHTML = 'Non ci sono altri articoli';
                    btn.disabled = true;
                    loading = false;
                }
            })
            .catch(error => {
                console.error('Errore durante il caricamento AJAX:', error);
                btn.innerHTML = 'Errore, riprova';
                btn.disabled = false;
                loading = false;
                page--; // 👉 Rollback della pagina in caso di errore
            });
    });
}
